import React from 'react';
import {
  createStyles, makeStyles, Theme, useMediaQuery, useTheme,
} from '@material-ui/core';
import { Add as AddIcon } from '@material-ui/icons';
import { Button } from '..';

const useStyles = makeStyles(({ palette }: Theme) => createStyles({
  root: {
    minWidth: 'unset',
    height: '34px',
    padding: '0 12px 0 11px',
    color: palette.buttonAction.color,
    background: palette.buttonAction.background,
    '&:hover': {
      backgroundColor: palette.buttonAction.background,
    },
  },
  label: {
    fontFamily: 'Montserrat, sans-serif',
    fontSize: '16px',
    fontWeight: 800,
    textTransform: 'none',
  },
}), { name: 'AddNewButton' });

type Props = {
  onAdd: () => void;
  title?: string;
  isRightSide?: boolean;
  disable?: boolean;
};

export const AddNewButton = ({
  onAdd,
  title = 'Add new',
  isRightSide = true,
  disable = false,
}: Props) => {
  const classes = useStyles();
  const theme = useTheme();
  const compact = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <div style={{ [isRightSide ? 'marginLeft' : 'marginRight']: '10px' }}>
      <Button
        disabled={disable}
        type="button"
        title={title}
        variant="contained"
        onClick={onAdd}
        classes={{
          root: classes.root,
          label: classes.label,
        }}
        data-intercom-target="Add button"
      >
        <AddIcon />
        {
          !compact && title
        }
      </Button>
    </div>
  );
};
